export default __webpack_public_path__ + "static/media/top_searched_right_arrow.c61dde43.svg";